var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-container",
    {
      attrs: {
        fluid: ""
      }
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "p",
                {
                  staticClass: "body-1"
                },
                [
                  _vm._v(
                    " In order to transfer a domain name to the GreenGeeks you will need to ensure that several required items and/or actions have been taken. Please ensure that you have all of the following required items and/or actions before you submit your domain transfer request. "
                  )
                ]
              ),
              _c(
                "ol",
                {
                  staticClass: "body-1"
                },
                [
                  _c("li", [
                    _vm._v(
                      "Domain has been registered for at least 60 days (there is a domain lock whereby a domain name cannot be transferred until after 60 days of the original registration). "
                    )
                  ]),
                  _c("li", [
                    _vm._v(
                      "Domain name is not expired or close to expiration date (expired domains or domains which are within 14 days of their expiration cannot be transferred). "
                    )
                  ]),
                  _c("li", [
                    _vm._v(
                      "Domain name has been unlocked (please contact the current registrar to do so)."
                    )
                  ]),
                  _c("li", [
                    _vm._v(
                      "Domain’s name servers are already pointed to the GreenGeeks name servers."
                    )
                  ]),
                  _c("li", [
                    _vm._v(
                      "You have the domain name EPP – Domain authorization code (contact your current registrar to obtain this code). "
                    )
                  ]),
                  _c("li", [
                    _vm._v(
                      "You are the administrative e-mail contact person on this domain name’s whois record (Whois privacy should be disabled). "
                    )
                  ])
                ]
              ),
              _c(
                "p",
                {
                  staticClass: "pt-3 body-1"
                },
                [
                  _vm._v(
                    " Once the above are completed, simply enter your EPP Authorization code along with the domain name you wish to transfer in the form above. Once placed our Domain Transfer Specalists will start the process and provide you with additional instructions if needed. "
                  )
                ]
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }